<template lang="pug">
  .notification
    i(:class="icon")
    strong
      small
        | &nbsp{{ config.titulo }}&nbsp
    br
    small
      | {{ config.texto }}&nbsp
      | {{ config.fecha }}
</template>

<script>
  export default {
    name: 'NotificacionConst',
    props: {
      config: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        icon: ''
      }
    },
    methods: {
      iniciarComponente() {
        switch (this.config.tipo) {
          case 'c':
            this.icon = 'fas fa-hammer'
            break
          case 'p':
            this.icon = 'fas fa-vial'
            break
          case 'pr':
            this.icon = 'fas fa-lightbulb'
            break
        }
      }
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/shared/NotificacionConst.vue